import { AddressSearchField } from '@parsys/frontend_library';
import React from 'react';

import { CUSTOM_EVENTS, formColors } from '../../utils/constants';
import { getCorrectFieldIdFromContext } from '../../utils/getCorrectFieldIdFromContext';
import i18n from 'FRONTEND/utils/i18n';

// Same styling as the Select2 theme for select fields
const sxStyling = {
  outerContainer: {
    flexDirection: 'column',
  },
  inputLabel: {
    fontWeight: 700,
    fontSize: 'inherit',
    color: 'inherit',
  },
  innerContainer: {
    backgroundColor: formColors.white,
    border: `1px solid ${formColors.lightGrey}`,
    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
    borderRadius: '15px',
    height: '35px',
    alignItems: 'center',
    '&:focus-within': {
      borderColor: formColors.inputBorder,
      boxShadow: `inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px ${formColors.inputBoxShadow}`,
    },
  },
  listBox: {
    '& .MuiAutocomplete-option[aria-selected="true"]': { // css applied when choice is selected
      color: formColors.selectedItem,
    },
    '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': { // css applied when choice is being hovered
      color: formColors.selectedItem,
    },
    '& .MuiAutocomplete-option[aria-selected="false"].Mui-focused': { // css applied when choice is being hovered
      color: formColors.selectedItem,
    },
  },
  closeIcon: {
    alignSelf: 'center',
    display: 'flex',
    marginRight: '10px',
    cursor: 'pointer',
    visibility: 'visible',
    '& .MuiSvgIcon-root': {
      marginRight: '10px',
    },
    color: 'inherit',
  },
};

const additionalClasses = {
  outerContainer: 'form-group',
};

const AddressSearchFieldComponent = ({ id, label, bindToFieldsIds, examType, context }) => {
  const handleChange = ({ id, value }) => {
    // since the Cloud doesn't handle its form with Redux, we need to update the form elements the old fashioned way
    // Patient context has a different formatting for its field (patient-{id})
    const cloudFormattedFieldId = getCorrectFieldIdFromContext(context, id, examType);
    const formElement = document.getElementById(cloudFormattedFieldId);
    if (formElement) {
      // if we don't have a value, it's a delete action, hence we clear the relevant input by assigning an empty string as the value
      formElement.value = value ?? '';

      const customEvent = new CustomEvent(CUSTOM_EVENTS.FIELD_UPDATED, {
        bubbles: true,
        detail: { id: cloudFormattedFieldId, value },
      });
      formElement.dispatchEvent(customEvent);
    } else {
      console.warn('An id and value was recieved from the AddressSearch but no corresponding input was found');
    }
  };
  return (
    <AddressSearchField
      id={id}
      label={label}
      bindToFieldIds={bindToFieldsIds}
      sxStyles={sxStyling}
      onChange={handleChange}
      onClear={handleChange}
      additionalClasses={additionalClasses}
      noOptionsText={{
        needMoreInput: i18n._('Type at least 3 characters to start your search.'),
        errorTExt: i18n._('An error occured while fetching options. Please try again later.'),
        noMatch: i18n._('No match found.'),
        loading: i18n._('Loading...'),
      }}
    />
  );
};

export default AddressSearchFieldComponent;
